import React from 'react';
import { Typography, Row, Col, Divider, Button, Modal } from 'antd';
const { Text, Link, Paragraph } = Typography;
import { ApplicationData } from '@bwb-buildings-mono/entities';
import * as UI from '@bwb-buildings-mono/ui';

const BUILDING_NAME = 'Metro Art Brentwood';
const BUILDING_ADDRESS_1 = '11771 Montana Ave.';
const BUILDING_ADDRESS_2 = 'Los Angeles, CA 90049';

const PHONE_NUMBER = '(310)896-5554';
const EMAIL = 'mike@metroart.com';

const tours =[
    {
        name: 'Lobby and Courtyard Tour',
        url: 'https://my.matterport.com/show/?model=KhDFZp47TLA&play=1'
    },
    {
        name: '2BR, 2BA Tour - ~1565 SF',
        url: 'https://my.matterport.com/show/?model=imJFQRj3AQa&play=1'
    },
    {
        name: '2BR, 2BA Tour - ~1450 SF',
        url: 'https://my.matterport.com/show/?model=ReKPgLsF8HR&play=1'
    },
    {
        name: '2BR, 2BA Tour - ~1660 SF',
        url: 'https://my.matterport.com/show/?model=Hn8eDdgQtKw&play=1'
    }
];

const amentities = {
    sentence: <div style={{fontSize: '18px', lineHeight: '18px', textAlign: 'center'}}>
      <Paragraph><Text mark strong>Great location</Text> close to restaurants, shops & more!</Paragraph>
      <Paragraph>Included parking in a secure garage.</Paragraph>
      <Paragraph>Intercom entry and secure access.</Paragraph>
      <Paragraph>Professional <Text mark strong>&nbsp;on-site manager&nbsp;</Text>.</Paragraph>
      <Paragraph>Fully equipped <Text mark strong>fitness center</Text> with quality equipment.</Paragraph>
      <Paragraph>Cat friendly, no dogs.</Paragraph>
    </div>,
    images: [
      {
        src: 'assets/web/common-1.jpg',
        caption: '',
        thumb: 'assets/web/common-1.jpg'
      },
      {
        src: 'assets/web/common-2.jpg',
        caption: '',
        thumb: 'assets/web/common-2.jpg'
      },
      {
        src: 'assets/web/common-3.jpg',
        caption: '',
        thumb: 'assets/web/common-3.jpg'
      },
      {
        src: 'assets/web/common-4.jpg',
        caption: '',
        thumb: 'assets/web/common-4.jpg'
      }
    ]
}

const features = {
    sentence: <div style={{fontSize: '18px', lineHeight: '18px', textAlign: 'center'}}>
        <Paragraph>Spacious layouts with ample space (1450-1700 sf!)</Paragraph>
        <Paragraph>Bright, open floor plans build to <Text mark strong>condominium quality</Text>.</Paragraph>
        <Paragraph>Tall 9' to 12' ceilings.</Paragraph>
        <Paragraph><Text mark strong>Full-size washer and dryer</Text> in every unit.</Paragraph>
        <Paragraph><Text mark strong>Upgraded stainless steel appliances</Text>.</Paragraph>
        <Paragraph>Bright laminate wood flooring, custom self-closing wood cabinets.</Paragraph>
        <Paragraph><Text mark strong>Large balconies or patios</Text>.</Paragraph>
        <Paragraph>Spacious <Text mark strong>walk-in closets</Text></Paragraph>
        <Paragraph>Granite kitchen counters.</Paragraph>
    </div>,
    sentenceMore: <div style={{fontSize: '18px', lineHeight: '18px', textAlign: 'center'}}>
        <Row gutter={24}>
            <Col sm={24} md={12}>
                <Divider>Our Apartments</Divider>
                <Paragraph>All of the above and...</Paragraph>
                <Paragraph>New carpet in bedroom areas</Paragraph>
                <Paragraph>Ceramic tile in bathrooms</Paragraph>
                <Paragraph>Oversized bathrooms with travertine counters</Paragraph>
                <Paragraph><Text mark strong>Large oval soaking tubs</Text> in all master bathrooms</Paragraph>
                <Paragraph><Text mark strong>dual sinks</Text> with <Text mark strong>separate tub and shower</Text> in master bath.</Paragraph>
                <Paragraph>Recessed Lighting</Paragraph>
                <Paragraph>Central heat and air conditioning</Paragraph>
                <Paragraph>Glass shower enclosures</Paragraph>
            </Col>
            <Col sm={24} md={12}>
                <Divider>State-of-the-art Technology</Divider>
                <Paragraph>Advanced media box in each apartment for TV and Internet</Paragraph>
                <Paragraph><Text mark strong>Dual pane windows</Text> with efficient low energy glazing</Paragraph>
                <Paragraph>Separate water system and <Text mark strong>individual water heaters</Text> in each unit</Paragraph>
                <Paragraph><Text mark strong>Skylights</Text> in top floor units</Paragraph>
                <Paragraph>Controlled access entry with RFID and intercom</Paragraph>
                <Paragraph>Cameras at all entry and exits to building for added security</Paragraph>
                <Divider>Metro Art Quality</Divider>
                <Paragraph>Wide, well lit corridors decorated with artwork</Paragraph>
                <Paragraph>Secure, easy-access parking located beneath the building</Paragraph>
                <Paragraph>Two oversized elevators with tall ceilings from parking to all levels</Paragraph>
                <Paragraph>Impressive two story lobby</Paragraph>
                <Paragraph>Landscaped courtyard with fountain</Paragraph>
            </Col>
        </Row>
    </div>,
  images: [
    [
        {
            src: 'assets/web/unit-2.jpg',
            caption: '',
            thumb: 'assets/web/unit-2.jpg'
        },
    ],
    {
        src: 'assets/web/unit-5.jpg',
        caption: '',
        thumb: 'assets/web/unit-5.jpg'
    },
    {
        src: 'assets/web/unit-6.jpg',
        caption: '',
        thumb: 'assets/web/unit-6.jpg'
    },
    {
        src: 'assets/web/unit-7.jpg',
        caption: '',
        thumb: 'assets/web/unit-7.jpg'
    },
    {
        src: 'assets/web/unit-8.jpg',
        caption: '',
        thumb: 'assets/web/unit-8.jpg'
    },
    {
        src: 'assets/web/unit-1.jpg',
        caption: '',
        thumb: 'assets/web/unit-1.jpg'
    },
    {
        src: 'assets/web/unit-4.jpg',
        caption: '',
        thumb: 'assets/web/unit-4.jpg'
    },
    {
        src: 'assets/web/unit-11.jpg',
        caption: '',
        thumb: 'assets/web/unit-11.jpg'
    },
    {
        src: 'assets/web/unit-15.jpg',
        caption: '',
        thumb: 'assets/web/unit-15.jpg'
    },
    {
        src: 'assets/web/unit-17.jpg',
        caption: '',
        thumb: 'assets/web/unit-17.jpg'
    },
  ]
}

export const AppData:ApplicationData = {
    footer: <div>
        <div>
            <Row>
                <Col md={24} xs={0}>
                    { BUILDING_NAME } — { BUILDING_ADDRESS_1 } , { BUILDING_ADDRESS_2 } — { PHONE_NUMBER }
                </Col>
                <Col md={0} xs={24}>
                    { BUILDING_NAME }<br/>
                    { BUILDING_ADDRESS_1 }<br/>
                    { BUILDING_ADDRESS_2 }<br/>
                    <a href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</a>
                </Col>
            </Row>
        </div>
        <div style={{fontSize: '80%', marginTop: '24px'}}>
            <div>The { BUILDING_NAME } is located in or around BRENTWOOD, WEST LA, WESTWOOD, SANTA MONICA, WEST SIDE</div>
            <div>Thank You For Looking, We Look Forward to Helping You!</div>
        </div>
    </div>,
    sections: [
        {
            element: UI.Logo,
            props: {
                name: BUILDING_NAME,
                logo: <img style={{height: '50px'}} src="./assets/logo.jpg"/>,
                address: <div style={{lineHeight: 1}}>
                    <div style={{fontSize: '80%'}}>{ BUILDING_ADDRESS_1 }, { BUILDING_ADDRESS_2 } <a href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</a></div>
                </div>
            }
        },
        {
            isNav: true,
            element: UI.Nav,
            props: {
                logo: {
                    logo: <img style={{height: '50px'}} src="./assets/logo.png"/>,
                    address: <div style={{lineHeight: 1}}>
                        <div style={{fontSize: '110%'}}>{ BUILDING_NAME }</div>
                        <div style={{fontSize: '80%'}}>{ BUILDING_ADDRESS_1 }</div>
                        <div style={{fontSize: '80%'}}>{ BUILDING_ADDRESS_2 }</div>
                        <div style={{fontSize: '80%'}}>{PHONE_NUMBER}</div>
                    </div>
                },
                rightSide: (
                    <UI.BookTourButton phone_number={PHONE_NUMBER} email={EMAIL}/>
                ),
                rightSideModal: (
                    <div>
                        <Paragraph>
                            <UI.VirtualToursButton tours={tours}/>
                        </Paragraph>
                        <Paragraph>
                            <UI.BookTourButton phone_number={PHONE_NUMBER} email={EMAIL}/>
                        </Paragraph>
                    </div>
                )
            }
        },
        {
            element: UI.HeroImage,
            props: {
                image: './assets/web/hero2.jpg'
            }
        },
        {
            element: UI.Tagline,
            props: {
                tagline: 'Spacious, luxury apartment homes in the heart of Brentwood.',
                undertag: <div>
                    <UI.VirtualToursButton tours={tours}/>
                    <UI.BookTourButton phone_number={PHONE_NUMBER} email={EMAIL}/>
                </div>
            }
        },
        
        {
            element: UI.AboveFold,
            props: {
                images: [
                    './assets/web/fold-1.jpg',
                    './assets/web/fold-2.jpg',
                    './assets/web/fold-3.jpg',
                    './assets/web/fold-4.jpg',
                    './assets/web/fold-5.jpg'
                ]
            }
        },
        {
            element: UI.SectionTextCarousel,
            label: UI.NAV_ITEM.UNITS,
            nav: 'Units',
            props: {
                title: 'About Our Apartments',
                sections: [features]
            }
        },
        {
            element: UI.SectionTextCarousel,
            label: UI.NAV_ITEM.AMENITIES,
            nav: 'Amenities',
            props: {
                title: 'Community Amenities',
                sections: [amentities]
            }
        },
        {
            element: UI.SectionImages,
            label: UI.NAV_ITEM.FLOORPLANS,
            nav: 'Floorplans',
            props: {
                title: 'Floorplans',
                imageProps: { xs: 24, sm: 12, md: 12, lg: 8 },
                images: [
                    "./assets/floorplans/lombard.jpg",
                    "./assets/floorplans/gable.jpg",
                    "./assets/floorplans/hepburn.jpg",
                    "./assets/floorplans/bogart.jpg",
                    "./assets/floorplans/olivier.jpg",
                    "./assets/floorplans/fairbanks.jpg",
                    "./assets/floorplans/guide.jpg",
                ]
            }
        },
        {
            element: UI.SectionTitle,
            label: UI.NAV_ITEM.CONTACT,
            nav: 'Tour',
            props: {
                title: 'Tour'
            }
        },
        {
            element: UI.SectionSideBySide,
            props: {
                leftSide: <div>
                    <h3>Schedule a tour with our on-site manager:</h3>
                    <div style={{marginTop: 24}}>
                        <h1 style={{}}><a href={`tel:${PHONE_NUMBER}`}>{ PHONE_NUMBER }</a></h1>
                        <div style={{fontSize: '80%'}}>Call anytime!</div>
                    </div>
                    <div style={{marginTop: 24}}>
                        <h1 style={{}}><a href={`mailto:${EMAIL}`}>{ EMAIL }</a></h1>
                        <div style={{fontSize: '80%'}}>Email us what you are looking for and some times that work for you.</div>
                    </div>
                    <div style={{marginTop: 24}}>
                        <Paragraph>
                            <UI.VirtualToursButton tours={tours}/>
                        </Paragraph>
                        <Paragraph>
                            <UI.BookTourButton phone_number={PHONE_NUMBER} email={EMAIL}/>
                        </Paragraph>
                    </div>
                </div>,
                rightSide: (
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d776.5186823701251!2d-118.4682425936594!3d34.05379470933858!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2bca735c68b33%3A0x730218c57f53c782!2s11771%20Montana%20Ave%2C%20Los%20Angeles%2C%20CA%2090049!5e0!3m2!1sen!2sus!4v1597782999826!5m2!1sen!2sus" width="600" height="450" frameBorder={0} style={{border:"1px solid #CCC"}}></iframe>
                )
            }
        }
    ]
}

